module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg10-bd4547efc75b599e7972ec1c38a9b6ca.jpg";